import React from "react";
import {TextField} from "@material-ui/core";

export default function InputField({onChange, ...rest}){
    const handleChange = event => {
        onChange(event.target.value)
    };

    return (
        <TextField
            fullWidth
            margin='none'
            onChange={handleChange}
            {...rest}
        />
    )
};